package com.hyperether.goodjob.scenes.register

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.app_name
import com.hyperether.goodjob.resources.goodjob_logo
import com.hyperether.goodjob.resources.register_msg
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.util.WEB_SCREEN_SIZE_LIMIT
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResourcePlain
import org.jetbrains.compose.resources.painterResource

@Composable
fun RegisterHolderView(
    content: @Composable () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxSize()
            .background(Color.White)
    ) {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .weight(2f)
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color(0xFF204866),
                            Color(0xFF142D40)
                        )
                    )
                )
                .padding(start = 100.toScaleDp()),
            contentAlignment = Alignment.CenterEnd
        ) {
            Column(
                modifier = Modifier
                    .verticalScroll(rememberScrollState())
                    .disableMouseDragScrollOnWeb()
                    .widthIn(max = WEB_SCREEN_SIZE_LIMIT * (2f / 3.5f))
                    .fillMaxWidth()
                    .padding(end = 30.toScaleDp()),
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Center
            ) {
                Image(
                    painter = painterResource(Res.drawable.goodjob_logo),
                    contentDescription = null,
                    modifier = Modifier.size(70.toScaleDp())
                )
                Spacer(modifier = Modifier.height(10.toScaleDp()))
                Text(
                    text = stringResourcePlain(Res.string.app_name),
                    fontSize = 40.toScaleSp(),
                    color = Color.White
                )
                Text(
                    text = stringResourcePlain(Res.string.register_msg),
                    fontSize = 18.toScaleSp(),
                    color = Color.White
                )
            }
            //TODO add bottom lines from Figma
//                Image(
//                    modifier = Modifier.align(Alignment.BottomStart),
//                    painter = painterResource(Res.drawable.background_lines),
//                    contentDescription = null
//                )
        }

        Box(
            modifier = Modifier
                .fillMaxHeight()
                .weight(1.5f),
            contentAlignment = Alignment.CenterStart
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = WEB_SCREEN_SIZE_LIMIT * (1.5f / 3.5f))
                    .fillMaxWidth(),
                verticalArrangement = Arrangement.Center
            ) {
                content()
            }
        }
    }
}